// JsFromRoutes CacheKey 10453d96e1417558b1041f720e1ff76e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/:org_nano_id/setup/power_through'),
}
